module.exports = __webpack_public_path__ + "r.no2.62a44b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/r.no2.jpg
// module id = rpPi
// module chunks = 0